import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {DropdownOption} from '../../../../../../models/dropdown-option.model';
import * as Validation from '../../../../../shared/constants/validation.constants';
import {FormControl, FormGroup} from '@angular/forms';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../../../state/app.state';
import {CommonService} from '../../../../../shared/services/common.service';
import {roles} from '../../../../../shared/constants/common.constants';
import {GroupDashboardService} from '../../../services/group-dashboard.service';
import {FetchUserStatusListFilterRequest, FetchGroupsTypeFilterRequest} from '../../../core/group-dashboard.actions';
import {userStatusListFilter, groupsTypeFilter} from '../../../core/group-dashboard.selector';

@Component({
  selector: 'app-participant-or-caregiver-information-filter',
  templateUrl: './participant-or-caregiver-information-filter.component.html',
  styleUrls: ['./participant-or-caregiver-information-filter.component.css']
})
export class ParticipantOrCaregiverInformationFilterComponent implements OnInit, OnDestroy {

  private readonly OnDestroy: Subject<any> = new Subject<any>();
  roleFilterList: DropdownOption[] = [
    {
      key: roles.adult,
      value: 'Adult',
    },
    {
      key: roles.participant,
      value: 'Participant',
    },
  ];
  statusFilterList: DropdownOption[] = [];
  groupsTypeFilter: DropdownOption[] = [];
  errorMessages: any = {};
  validation = Validation;
  errorMessageMap = {
    'groupType': {},
    'role': {},
    'status': {},
    'searchText': {},
  }

  form = new FormGroup({
    groupType: new FormControl(null),
    role: new FormControl(null),
    status: new FormControl(null),
    searchText: new FormControl(null),
  })

  constructor(
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private groupDashboardService: GroupDashboardService,
  ) {
    this.store.dispatch(FetchGroupsTypeFilterRequest());
    this.store.dispatch(FetchUserStatusListFilterRequest())
  }

  ngOnInit() {
    this.store
      .select(groupsTypeFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.groupsTypeFilter = data.list
      });

    this.store.select(userStatusListFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((data) => {
        this.statusFilterList = data.list;
      });
  }

  apply() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    if (!this.form.dirty) { // check is there any change
      return;
    }
    // changes just applied, so marking the form as un-dirty to avoid applying same filters again without changing anything
    this.form.markAsPristine();

    // EXTRACT VALUE FROM FORM//
    const filters = this.form.getRawValue();
    this.groupDashboardService.onParticipantCaregiverFilterChange.next(filters)
  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }

}
